import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-sm font-bold uppercase tracking-wider transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C9A84C] disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#C9A84C] text-black hover:bg-[#F0C040] shadow-[0_0_15px_rgba(201,168,76,0.3)] hover:shadow-[0_0_25px_rgba(201,168,76,0.5)] border border-transparent',
    outline: 'bg-transparent text-[#C9A84C] border border-[#C9A84C] hover:bg-[#C9A84C]/10',
    ghost: 'bg-transparent text-gray-400 hover:text-[#C9A84C] hover:bg-white/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-12 px-8 text-sm',
    lg: 'h-14 px-10 text-base md:text-lg'
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading} {...props} data-id="element-457">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-458" />}
        {children}
      </motion.button>;
});
Button.displayName = 'Button';